import { EtherscanImg } from "app/constants";

const EtherscanIcon = () => {
  return <img width="24" height="24" src={EtherscanImg} alt="etherscan-icon" />;
};

export default EtherscanIcon;
